import { h } from './h';
import { fadeIn, fadeOut } from './animations';
import { close as closeIcon } from './constants';

export type TOptions = {
  title: string;
  content: string;
  buttonCancel?: string;
  buttonConfirm?: string;
  placeholderText?: string;
  submitText?: string;
  useInnerHTML?: boolean;
  animation?: 'fade' | false;

  onCancel?: (self: Component) => void;
  onConfirm?: (self: Component) => void;
  onSubmit?: (self: Component, value: string) => void;

  beforeRender?: (self: Component) => void;
  afterRender?: (self: Component) => void;
  beforeClose?: (self: Component) => void;
  afterClose?: (self: Component) => void;
};

export class Component {
  public options: TOptions;
  public title: string;
  public content: string;
  public useInnerHTML: boolean;
  public animation: 'fade' | false;
  public template: HTMLElement;
  public port?: HTMLElement;
  public container?: HTMLElement;

  constructor(options: TOptions) {
    this.options = options;

    this.title = options.title;
    this.content = options.content;
    this.useInnerHTML = options.useInnerHTML === true;

    if (typeof options.animation !== 'undefined') {
      this.animation = options.animation;
    } else {
      this.animation = 'fade';
    }

    this.template = this.createBase();
  }

  createBase() {
    const close = h('div', {
      class: 'close',
      click: () => {
        this.close();
      },
    });
    close.innerHTML = closeIcon;

    this.port = h('div', { class: 'port' });

    let style;

    if (this.animation === 'fade') {
      style = 'opacity:0;';
    } else {
      style = '';
    }

    this.container = h('div', { class: 'attention-component', style: style }, [
      h('div', { class: 'inner' }, [h('div', { class: 'content' }, [close, this.port])]),
    ]);

    return this.container;
  }

  render(container = document.body) {
    if (this.options.beforeRender) {
      this.options.beforeRender(this);
    }

    container.appendChild(this.template);

    if (this.options.afterRender) {
      this.options.afterRender(this);
    }

    if (this.animation === 'fade') {
      fadeIn(this.template);
    }
  }

  destroy() {
    this.container?.parentElement?.removeChild(this.container);

    if (this.options.afterClose) {
      this.options.afterClose(this);
    }
  }

  close() {
    if (this.options.beforeClose) {
      this.options.beforeClose(this);
    }

    if (!this.animation) {
      this.destroy();
    } else if (this.animation === 'fade') {
      fadeOut(this.container as HTMLElement, () => {
        this.destroy();
      });
    }
  }
}
